

































import { Component, Vue } from "vue-property-decorator";
import { TUTORIAL } from "@/resources/constants/onboarding";
@Component({
  name: "tutorial-modal-component",
})
export default class ExitModalComponent extends Vue {
  TUTORIAL = TUTORIAL;
  get active(): boolean {
    return this.$store.getters["SystemStore/getTutorialModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setShowTutorialModalAction", e);
  }
  get step(): number {
    return this.$store.getters["SystemStore/getTutorialText"];
  }
  nextStep() {
    this.$store?.dispatch("SystemStore/setTutorialTextAction", 1);
    this.$store?.dispatch("GraphicClientStore/beginTutorial");
  }
}
